import { IllustrationHousesBackground } from '@bbl-digital/snorre'
import { useTheme } from '@emotion/react'
import { FCWithChildren } from 'global'
import { getLogo } from 'shared/utils/theme'
import { Content, Img, Overlay } from './styles'
import { motion } from 'motion/react'

const OverlayWithComposition: FCWithChildren = ({ children }) => {
  const theme = useTheme()

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.4 }}
    >
      <Overlay>
        <Img alt="logo" src={getLogo()} />
        <Content theme={theme}>{children}</Content>

        <IllustrationHousesBackground height="159px" />
      </Overlay>
    </motion.div>
  )
}

export default OverlayWithComposition
